import {
  GET_USER_APPS,
} from 'constants/users';

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_USER_APPS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
